import { Component, OnInit, OnDestroy } from '@angular/core';
import { TimelineStore } from '../timeline.store';
import { Subscriber } from 'rxjs/Subscriber';
import { TIMELINE_TICK_WIDTH } from '../../../constants';
import { getIntermediateValues } from '../../../shared/helpers/get-intermediate-values';
import { lowerDividend } from '../../../shared/helpers/math.helpers';
import { Milliseconds } from '../../../types';

@Component({
  selector: 'app-timeline-scale',
  templateUrl: './timeline-scale.component.html',
  styleUrls: ['./timeline-scale.component.styl']
})
export class TimelineScaleComponent implements OnInit, OnDestroy {
  public tickPositions: Milliseconds[] = [];

  public timelineChangeSubscriber: Subscriber<number>;

  private previousStartValue: Milliseconds;
  private previousEndValue: Milliseconds;
  private previousStep: Milliseconds;

  constructor(public timelineStore: TimelineStore) {
  }

  ngOnInit() {
    this.updateTickPositions();

    this.timelineChangeSubscriber = this.timelineStore.change
      .subscribe(() => this.updateTickPositions());
  }

  ngOnDestroy() {
    this.timelineChangeSubscriber.unsubscribe();
  }

  private updateTickPositions() {
    this.tickPositions = this.getTickPositions();
  }

  private getTickPositions() {
    const step = this.timelineStore.convertPixelsToMilliseconds(TIMELINE_TICK_WIDTH);
    const startValue = lowerDividend(this.timelineStore.startVisiblePosition, step);
    const endValue = lowerDividend(this.timelineStore.endVisiblePosition, step);

    if (this.shouldPositionsUpdate(startValue, endValue, step)) {
      this.previousStep = step;
      this.previousStartValue = startValue;
      this.previousEndValue = endValue;

      return getIntermediateValues(startValue, endValue, step);
    } else {
      return this.tickPositions;
    }
  }

  private shouldPositionsUpdate(startValue: Milliseconds, endValue: Milliseconds, step: Milliseconds): boolean {
    return startValue !== this.previousStartValue ||
      endValue !== this.previousEndValue ||
      step !== this.previousStep;
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-scale/timeline-scale.component.ts